import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';
import TypeWrite from '../../components/TypeWrite';
import { ContainerBanner, SHome } from '../../styles/pages/Home';
import About from './About';
import Contact from './Contact';
import Education from './Education';
import Experience from './Experience';
import Portifolio from './Portifolio';
import Skills from './Skills';


const Home: React.FC = () => {
  return (
    <SHome>
      <section className='first-section' id='home'>
        <div className='container'>
          <ContainerBanner>
            <div>
              <h2>Olá, Eu sou</h2>
              <TypeWrite values={['Patrick Assunção']} />
              <p>
                DEVELOPMENT
              </p>
              <Link to={{ pathname: '/', hash: '#contact' }}>
                <Button text='Entre em Contato' />
              </Link>
            </div>

            <div>
              <span>
                <img src='/img/img.png' alt='manaus' />
              </span>
            </div>
          </ContainerBanner>
        </div>
      </section>

      <About />
      <div id="resume">
        <Experience />
        <Education />
        <Skills />
      </div>

      <Portifolio />
      <Contact />
    </SHome>
  );
}

export default Home;